import { render, staticRenderFns } from "./TheTableLog.vue?vue&type=template&id=33cc1af3&scoped=true&"
import script from "./TheTableLog.vue?vue&type=script&lang=ts&"
export * from "./TheTableLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cc1af3",
  null
  
)

export default component.exports